<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title>{{$t(formName)}}</v-toolbar-title>
            <v-divider
                    class="mx-2"
                    inset
                    vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{$t( formTitle) }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-select :items="attachTypes.items" :label="$t('lang.files.attachTypeId')"
                                              v-model="editedItem.attachTypeId"
                                              name="attachTypeId"
                                              item-value="id"
                                              item-text="name"
                                              v-validate="'required'"
                                              :data-vv-as="$t('lang.files.attachTypeId')"
                                              :error-messages="errors.first('attachTypeId')"
                                    />

                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field append-icon="" v-validate="'required'"
                                                  :label="$t('lang.files.attachCode')"
                                                  :data-vv-as="$t('lang.files.attachCode')"
                                                  v-model="editedItem.attachCode"
                                                  name="attachCode"
                                                  :error-messages="errors.first('attachCode')"></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field append-icon="" v-validate="'required'"
                                                  :label="$t('lang.files.attachName')"
                                                  :data-vv-as="$t('lang.files.attachName')"
                                                  v-model="editedItem.attachName"
                                                  name="attachName"
                                                  :error-messages="errors.first('attachName')"></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <i-upload
                                            :label="$t('lang.files.attach')"
                                            name="attachId" id="attachId"
                                            v-model="editedItem.attachId"
                                            inputType="button"
                                            multifile="multifile"/>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="save">
                            <v-icon dark left>save</v-icon>
                            {{$t('lang.common.save')}}
                        </v-btn>

                        <v-btn color="error" @click="close">
                            <v-icon dark left>cancel</v-icon>
                            {{$t('lang.common.cancel')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-btn color="primary" @click="addItem">
                <v-icon dark left>add</v-icon>
                {{$t('lang.common.add')}}
            </v-btn>
        </v-toolbar>
        <v-data-table
                :headers="headers"
                :items="items"
                class="elevation-1 gru-table fixed-header"
        >
            <template slot="headers">
                <tr>
                    <th v-for="header in headers" :width="header.width"
                    >
                        {{$t(header.text)}}
                    </th>
                </tr>
            </template>
            <template v-slot:items="props">
                <td>
                    <div v-for="(s_item, index) in attachTypes.items"
                         v-bind:key="index">
                        <div v-if="s_item['id'] === props.item.attachTypeId">
                            {{ s_item['name'] }}
                        </div>
                    </div>
                </td>
                <td>{{ props.item.attachCode }}</td>
                <td>{{ props.item.attachName }}</td>
                <td>
                    <i-upload label="File đính kèm" name="attachId" inputType="nobutton"
                              v-model="props.item.attachId" multifile="true"
                              readonly="true"
                              fileType="normal"
                    />
                </td>
                <td style="text-align: center; vertical-align: middle;">
                    <v-btn depressed outline icon fab dark color="primary" small @click="editItem(props.item)"
                           title="Clear">
                        <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn depressed outline icon fab dark color="red" small @click="deleteItem(props.item)"
                           title="Clear">
                        <v-icon>delete</v-icon>
                    </v-btn>
                </td>
            </template>
            <template v-slot:no-data>
                Không có dữ liệu
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import IUpload from "../../../components/form/Upload";
    import axios from "axios";
    import {message} from "@/shared/message";

    export default {
        name: "FileAttachComponent",
        components: {IUpload},
        props: {
            defaultData: {
                type: Array,
                default: () => []
            },
            formName: {
                type: String,
                default: 'FileAttachComponent List'
            },
        },
        data: () => ({
            dialog: false,
            multifile : true,
            headers: [
                {
                    text: 'lang.files.attachTypeId',
                    align: 'center',
                    value: 'attachTypeId',
                    width: "20%"
                },
                {
                    text: 'lang.files.attachCode',
                    align: 'center',
                    value: 'attachCode',
                    width: "20%",
                    sortable: false
                },
                {
                    text: 'lang.files.attachName',
                    align: 'center',
                    value: 'attachName',
                    width: "20%",
                    sortable: false
                },
                {
                    text: 'lang.files.attachId',
                    align: 'center',
                    value: 'attachId',
                    width: "20%",
                    sortable: false
                }

            ],
            createItems: [
                {
                    name: "attachTypeId",
                    items: [],
                }
            ],
            items: [],
            addLabel: 'lang.files.add',
            editLabel: 'lang.files.edit',
            editedIndex: -1,
            editedItem: {
                attachTypeId: '',
                attachCode: '',
                attachName: null,
                attachId: ''
            },
            defaultItem: {
                attachTypeId: '',
                attachCode: '',
                attachName: '',
                attachId: '-1'
            },
            attachTypes: {}
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? this.addLabel : this.editLabel
            }
        },

        watch: {
            dialog(val) {
                val || this.close()
            },
            defaultData: function (value) {
                this.items = this.copyValue(value);
            }
        },

        created() {
            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/fileAttachType",).then(
                data => {
                    this.attachTypes = data;
                },
                error => {
                    console.log(error);
                }
            )

        },

        methods: {
            copyValue: function (value) {
                let ob = value.slice();
                return ob;
            },

            editItem(item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem(item) {
                const index = this.items.indexOf(item)
                confirm('Bạn có chắc chắn xóa ?') && this.items.splice(index, 1)
                this.$emit("input", this.items);
            },

            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },

            save() {
                this.$validator.validate().then(
                    valid => {
                        if (!valid) {
                            message.error(this.$t('lang.common.validate_fail'));
                            return;
                        }
                        if (this.editedIndex > -1) {
                            Object.assign(this.items[this.editedIndex], this.editedItem)
                        } else {
                            this.items.push(this.editedItem)
                        }
                        this.close()
                        this.$emit("input", this.items);

                    }
                )

            },
            addItem() {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1;
                this.dialog = true;
            }
        }
    }
</script>